//===================================
// Video full
//===================================

import { loadScript } from '../utils';

const VideoFull = (ele) => {
  let instance, built = false;
  const modal = ele.querySelector('.modal');
  const config = JSON.parse(ele.querySelector('script.config').textContent);

  if (!config) return;

  const init = () => {
    modal.addEventListener('close', onClose);
    modal.addEventListener('open', onOpen);
  }

  const onClose = () => {
    instance.pause();
  }

  const onOpen = () => {
    if (!built) buildModal();
    
    loadScript('https://player.vimeo.com/api/player.js', {onLoad: play});
  }

  const buildIframe = () => {
    const iframe = document.createElement('iframe');
    iframe.src = config.video_url;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.frameborder = '0';
    iframe.allow = 'autoplay; fullscreen';
    iframe.allowfullscreen = true;

    return iframe;
  }

  const buildModal = () => {
    built = true;
    modal.querySelector('.video-container').appendChild(buildIframe());
  }

  const play = () => {
    if (!instance) { 
      const player = modal.querySelector('iframe');
      instance = new Vimeo.Player(player);
    }

    instance.play();
  }

  init();
}

document.addEventListener('DOMContentLoaded', () => {
  const eles = document.querySelectorAll('.video-full');

  eles.forEach(ele => {
    VideoFull(ele);
  });
});
